import axios from 'axios'
import { SearchIcon, LocationIcon, BedIcon, CurrencyIcon } from '../assets/CommonIcons'
import { useEffect, useState } from 'react'
import '../../static/css/main.css'
import InputField from './_searchField'
import { ChooseTypeField } from './_searchField'
import NewImvSearch from './NewImvSearch'
import { useNavigate } from 'react-router-dom'


export default function ImvSearch() {
    const [FormData, setFormData] = useState({
        local: '',
        quartos: '2 Quartos ou Mais',
        tipo: 'Alugel',
        valor: 'Max R$1.000/mês'
    })
    //* Estado do Tipo de Imóvel Selecionado -> ['Aluguel' ou 'Venda]
    const [typeField, setTypeField] = useState('Aluguel')
    const [bairrosList, setBairrosList] = useState([])
    const navigate = useNavigate()

    const handleSubmit = () => {
        const filters = JSON.stringify(FormData)
        navigate(`/pesquisa?filters=${filters}`)
        // window.alert('Esta opçao estará diponivel em Breve ...')
    }

    useEffect(() => {
        const getBairros = async () => {
            try {
                const response = await axios.get('https://oxx-api.vercel.app/faiimoveis_/bairroslist/', {
                    headers: { 'api-key': 'xUp2jAz5hQZM#wCsKb' }
                })
                setBairrosList(response.data)
                setFormData((prevData) => ({ //* Inicializa os campos de formData com o primeiro item obtido da requisição (para nao deixar em branco)
                    ...prevData,
                    local: response.data[0]
                }))
            } catch (error) {
                console.error('Erro ao Definir Lista de Bairros: ', error)
            }
        }

        getBairros()
    }, [])

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            tipo: typeField
        }))
    }, [typeField])

    const sectionStyle = {
        background: 'url(sp_view.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        fontFamily: 'Poppins, sans-serif',
    }

    return <>
        {/* na pesquisa mostrar resultados para os parametros e separadamente resultados similares que nao batem exatamente com os parametros */}
        <section id='left-side-header' style={sectionStyle} className="flex md:h-96 md:p-5">
            
            {/* Formulario de Pesquisa de Imoveis */}
            <article className="w-full items-center flex max-md:m-0">
                <form className="grid mx-auto p-0 gap-y-10
                max-lg:w-full max-md:gap-1 2xl:w-3/5 max-[500px]:text-xs max-md:h-full max-md:rounded-none
                bg-gradient-to-b from-[#0000006b] to-[#0000] shadow-[0_0_2rem_#0007] backdrop-blur-lg rounded-lg">

                    <h1 className="text-[#fff] stroke text-5xl max-[500px]:text-4xl self-start xl:px-10 drop-shadow-xl shadow-white max-md:p-5 min-[768px]:p-8"> Encontre o Seu Imóvel Ideal </h1>

                    {/* Container dos Campos do Formulario */}
                    <div className='grid gap-y-10 px-10
                    max-md:px-3'>

                        <InputField actData={FormData} setData={setFormData} field={'location'} data={bairrosList} />

                        <InputField actData={FormData} setData={setFormData} field={'bedrooms'} />

                        <ChooseTypeField actData={FormData} setData={setFormData} setType={setTypeField} />

                        <InputField actData={FormData} setData={setFormData} field={'price'} typeField={typeField} />
                    </div>

                    {/* Botão para pesquisar */}
                    <div onClick={() => handleSubmit()} className='flex items-center justify-center rounded-b-lg max-[500px]:text-lg w-full bg-[#1d4aa775] justify-self-end p-5 transition hover:bg-[#1d4aa790] hover:cursor-pointer'>
                        <FieldIcon icon={<SearchIcon />} /> Pesquisar Imoveis
                    </div>
                </form>
            </article>

            <article className="w-full max-[1000px]:hidden">
                <NewImvSearch />
            </article>
        </section>
    </>
}


const FieldIcon = ({ icon }) => {
    return (
        <span className='w-10 aspect-square col-span-1 fill-white'>{icon}</span>
    )
}